import { render, staticRenderFns } from "./DisputeResolutionEscalations.vue?vue&type=template&id=163112e7&scoped=true&"
import script from "./DisputeResolutionEscalations.vue?vue&type=script&lang=js&"
export * from "./DisputeResolutionEscalations.vue?vue&type=script&lang=js&"
import style0 from "./DisputeResolutionEscalations.vue?vue&type=style&index=0&id=163112e7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "163112e7",
  null
  
)

export default component.exports